import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.project.resource.editor');
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-project-resource-editor',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.project.resource.editor/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  color: #253029;
}

.resource-editor-page {
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  gap: 20px;
  height: 100%;
  min-height: 0;
  box-sizing: border-box;
  padding: 28px;
  overflow: hidden;
  background: #f4f6f3;
}

.resource-editor-topbar {
  border: 1px solid #dce3dd;
  background: rgba(255, 255, 255, 0.92);
}

.resource-editor-back {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 0 13px;
  border: 1px solid #e0e5e1;
  background: #f8faf8;
  color: #59675e;
  white-space: nowrap;
}

.resource-editor-back:hover {
  border-color: #b9c7bd;
  color: #2f4035;
  background: #fff;
}

.resource-editor-back__short-label {
  display: none;
}

.resource-editor-topbar__title {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: flex-start;
  gap: 11px;
  padding-left: 16px;
  border-left: 1px solid #e2e7e3;
  text-align: left;
}

.resource-editor-topbar__title > div {
  min-width: 0;
}

.resource-editor-topbar__icon {
  display: grid;
  width: 42px;
  height: 42px;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 13px;
  background: #eaf3ed;
  color: #4f765e;
}

.resource-editor-topbar__icon.is-survey {
  background: #f3eef8;
  color: #775f8d;
}

.resource-editor-topbar__title p,
.resource-editor-topbar__title h1 {
  margin: 0;
}

.resource-editor-topbar__title p {
  color: #8a948d;
  font-size: 12px;
  font-weight: 700;
}

.resource-editor-topbar__title h1 {
  overflow: hidden;
  margin-top: 2px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.resource-editor-topbar__context {
  display: grid;
  gap: 2px;
  min-width: 190px;
  padding: 8px 12px;
  border-radius: 11px;
  background: #f4f7f4;
  text-align: right;
}

.resource-editor-topbar__context small {
  color: #929b95;
  font-size: 12px;
}

.resource-editor-topbar__context strong {
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
}

.resource-editor-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.75fr) minmax(360px, 0.9fr);
  gap: 18px;
  max-width: 1560px;
  width: 100%;
  height: auto;
  min-height: 0;
  margin: 0 auto;
}

.resource-editor-document,
.resource-editor-chat {
  min-height: 0;
  overflow: hidden;
  border: 1px solid #dce3dd;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 8px 30px rgba(34, 51, 41, 0.045);
}

.resource-editor-document {
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}

.resource-editor-document__header {
  position: sticky;
  z-index: 3;
  top: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  padding: 28px 32px 24px;
  border-bottom: 1px solid #e3e8e4;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(10px);
}

.resource-editor-document__header p,
.resource-editor-document__header h2,
.resource-editor-document__header span {
  margin: 0;
}

.resource-editor-document__header p {
  color: #ef6038;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
}

.resource-editor-document__header h2 {
  margin: 7px 0 5px;
  font-size: 23px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.resource-editor-document__header > div > span {
  color: #7f8982;
  font-size: 12px;
}

.resource-editor-version {
  display: grid;
  min-width: 175px;
  gap: 5px;
  color: #7b867f;
  font-size: 12px;
  font-weight: 700;
}

.resource-editor-version select {
  width: 100%;
  border: 1px solid #d8dfd9;
  border-radius: 10px;
  background: #fff;
  padding: 9px 30px 9px 11px;
  color: #344138;
  font-size: 12px;
  font-weight: 700;
}

.resource-editor-document__actions {
  display: flex;
  min-width: 210px;
  flex-direction: column;
  align-items: stretch;
  gap: 9px;
}

.resource-editor-register-common,
.resource-editor-common-state {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.resource-editor-register-common {
  color: #fff;
  background: #56715e;
  border: 1px solid #56715e;
  cursor: pointer;
}

.resource-editor-register-common:hover,
.resource-editor-register-common:focus-visible {
  background: #405b49;
  border-color: #405b49;
  outline: 2px solid rgba(86, 113, 94, 0.22);
  outline-offset: 2px;
}

.resource-editor-register-common:disabled {
  color: #98a19a;
  background: #eff2ef;
  border-color: #dfe4df;
  cursor: not-allowed;
}

.resource-editor-common-state {
  color: #55705a;
  background: #edf4eb;
  border: 1px solid #ccdac8;
}

.resource-editor-template-picker {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(360px, 0.9fr);
  align-items: end;
  gap: 22px;
  padding: 18px 32px;
  border-bottom: 1px solid #e1e7e2;
  background: linear-gradient(100deg, #f4f8f3 0%, #fbfcfa 100%);
}

.resource-editor-template-picker.is-applied {
  background: linear-gradient(100deg, #edf5eb 0%, #f8fbf7 100%);
}

.resource-editor-template-picker__copy {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 13px;
}

.resource-editor-template-picker__copy > span {
  width: 42px;
  height: 42px;
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 12px;
  background: #e3eee1;
  color: #58735d;
  font-size: 15px;
}

.resource-editor-template-picker__copy > div {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.resource-editor-template-picker__copy small {
  color: #df5d3a;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
}

.resource-editor-template-picker__copy strong {
  color: #334038;
  font-size: 13px;
}

.resource-editor-template-picker__copy p {
  margin: 0;
  color: #7a867e;
  font-size: 12px;
  line-height: 1.5;
}

.resource-editor-template-picker__control {
  display: grid;
  grid-template-columns: minmax(190px, 1fr) auto;
  align-items: end;
  gap: 9px;
}

.resource-editor-template-picker__control label {
  min-width: 0;
  display: grid;
  gap: 5px;
}

.resource-editor-template-picker__control label > span {
  color: #718078;
  font-size: 12px;
  font-weight: 700;
}

.resource-editor-template-picker__control select,
.resource-editor-template-picker__control button {
  min-height: 40px;
  border: 1px solid #ced9d0;
  border-radius: 9px;
  font-size: 12px;
  font-weight: 700;
}

.resource-editor-template-picker__control select {
  width: 100%;
  min-width: 0;
  background: #fff;
  padding: 0 34px 0 11px;
  color: #344239;
}

.resource-editor-template-picker__control button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 14px;
  border-color: #56715e;
  background: #56715e;
  color: #fff;
  cursor: pointer;
  white-space: nowrap;
}

.resource-editor-template-picker__control button:disabled {
  border-color: #dce3dd;
  background: #edf1ed;
  color: #8d9890;
  cursor: not-allowed;
}

.resource-editor-template-lock {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 18px 32px 0;
  padding: 13px 15px;
  border: 1px solid #eed9b8;
  border-radius: 11px;
  background: #fff8eb;
  color: #7e6337;
}

.resource-editor-template-lock > i {
  margin-top: 2px;
}

.resource-editor-template-lock > div {
  display: grid;
  gap: 3px;
}

.resource-editor-template-lock strong {
  font-size: 12px;
}

.resource-editor-template-lock p {
  margin: 0;
  font-size: 12px;
  line-height: 1.55;
}

.resource-editor-document__meta {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 13px 32px;
  border-bottom: 1px solid #edf0ed;
  background: #fafbf9;
  color: #7c8780;
  font-size: 12px;
}

.resource-editor-document__meta span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.resource-editor-document__meta em {
  margin-left: auto;
  border-radius: 999px;
  background: #eaf5e9;
  padding: 5px 9px;
  color: #4e7659;
  font-style: normal;
  font-weight: 700;
}

.resource-editor-content {
  padding: 30px 32px 40px;
}

.resource-editor-content > header {
  display: flex;
  align-items: end;
  justify-content: space-between;
  margin-bottom: 19px;
}

.resource-editor-content > header small {
  color: #96a099;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.13em;
}

.resource-editor-content > header h3 {
  margin: 4px 0 0;
  font-size: 18px;
}

.resource-editor-content > header em {
  border-radius: 999px;
  background: #eef3ef;
  padding: 6px 10px;
  color: #647168;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.resource-editor-rules {
  display: grid;
  gap: 9px;
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: rule;
}

.resource-editor-rules li {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr);
  gap: 12px;
  align-items: start;
  padding: 15px 17px;
  border: 1px solid #e3e8e4;
  border-radius: 12px;
  background: #fff;
}

.resource-editor-rules li > span {
  display: grid;
  width: 27px;
  height: 27px;
  place-items: center;
  border-radius: 8px;
  background: #eef5ef;
  color: #51705a;
  font-size: 12px;
  font-weight: 700;
}

.resource-editor-rules p {
  margin: 2px 0 0;
  color: #39463e;
  font-size: 12px;
  line-height: 1.7;
}

.resource-editor-questions {
  display: grid;
  gap: 12px;
}

.resource-editor-questions article {
  border: 1px solid #e1e6e2;
  border-radius: 14px;
  padding: 17px;
}

.resource-editor-questions article > header {
  display: flex;
  gap: 12px;
}

.resource-editor-questions article > header > span {
  display: grid;
  width: 28px;
  height: 28px;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 8px;
  background: #f2edf7;
  color: #765e8e;
  font-size: 12px;
  font-weight: 700;
}

.resource-editor-questions small {
  color: #8f9992;
  font-size: 12px;
}

.resource-editor-questions h4 {
  margin: 3px 0 0;
  font-size: 12px;
  line-height: 1.55;
}

.resource-editor-options {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 13px 0 0 40px;
}

.resource-editor-options span {
  border-radius: 999px;
  background: #f6f3f8;
  padding: 5px 8px;
  color: #74687d;
  font-size: 12px;
}

.resource-editor-survey-result {
  padding: 0 32px 40px;
}

.resource-editor-survey-result > header {
  display: flex;
  align-items: end;
  justify-content: space-between;
  margin-bottom: 14px;
}

.resource-editor-survey-result > header small {
  color: #96a099;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.13em;
}

.resource-editor-survey-result > header h3 {
  margin: 4px 0 0;
  font-size: 18px;
}

.resource-editor-survey-result > header em {
  border-radius: 999px;
  background: #eef3ef;
  padding: 6px 10px;
  color: #647168;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.resource-editor-survey-result__form {
  overflow: hidden;
  border: 1px solid #dfe5e0;
  border-radius: 14px;
  background: #fff;
}

.resource-editor-survey-result__form > section {
  display: grid;
  grid-template-columns: 118px minmax(0, 1fr);
  min-height: 52px;
}

.resource-editor-survey-result__form > section + section {
  border-top: 1px solid #e6eae7;
}

.resource-editor-survey-result__form > section > small {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  background: #f7f9f7;
  color: #68746c;
  font-size: 12px;
  font-weight: 700;
}

.resource-editor-survey-result__values {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 7px;
  padding: 12px 15px;
}

.resource-editor-survey-result__values span {
  border: 1px solid #dce4de;
  border-radius: 999px;
  background: #f8faf8;
  padding: 6px 9px;
  color: #59665e;
  font-size: 12px;
  font-weight: 700;
}

.resource-editor-survey-result__values.is-decisions span {
  border-color: #d5e3d8;
  background: #edf5ef;
  color: #496b53;
}

.resource-editor-survey-result__values.is-issues span {
  border-color: #e3dbea;
  background: #f7f3f9;
  color: #705e7e;
}

.resource-editor-survey-result__comments {
  display: grid;
}

.resource-editor-survey-result__comments article {
  display: grid;
  grid-template-columns: minmax(130px, 0.45fr) minmax(0, 1fr);
  min-height: 56px;
  align-items: center;
}

.resource-editor-survey-result__comments article + article {
  border-top: 1px solid #edf0ed;
}

.resource-editor-survey-result__comments strong {
  padding: 13px 15px;
  color: #48544c;
  font-size: 12px;
}

.resource-editor-survey-result__comments span {
  align-self: stretch;
  border-left: 1px solid #edf0ed;
  padding: 14px 15px;
  color: #a0a8a2;
  font-size: 12px;
}

.resource-editor-empty {
  display: grid;
  justify-items: center;
  max-width: 620px;
  margin: 85px auto;
  padding: 0 32px;
  text-align: center;
}

.resource-editor-empty > span {
  display: grid;
  width: 60px;
  height: 60px;
  place-items: center;
  border-radius: 18px;
  background: #edf4ee;
  color: #577461;
  font-size: 22px;
}

.resource-editor-empty h2 {
  margin: 20px 0 8px;
  font-size: 20px;
}

.resource-editor-empty p {
  max-width: 520px;
  margin: 0;
  color: #7c8780;
  font-size: 12px;
  line-height: 1.7;
}

.resource-editor-empty ul {
  display: grid;
  gap: 8px;
  margin: 22px 0 0;
  padding: 0;
  list-style: none;
  color: #59665e;
  font-size: 12px;
  text-align: left;
}

.resource-editor-empty li {
  display: flex;
  align-items: center;
  gap: 8px;
}

.resource-editor-empty li i {
  color: #6d9279;
}

.resource-editor-empty.is-survey {
  max-width: 680px;
  margin: 48px auto;
}

.resource-editor-empty.is-survey > span {
  background: #f3eef8;
  color: #775f8d;
}

.resource-editor-empty__preview {
  width: 100%;
  margin-top: 26px;
  overflow: hidden;
  border: 1px solid #e1e5e2;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(54, 67, 58, 0.05);
  text-align: left;
}

.resource-editor-empty__preview > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px;
  border-bottom: 1px solid #e8ece9;
  background: #fafbf9;
}

.resource-editor-empty__preview > header > div {
  display: grid;
  gap: 4px;
}

.resource-editor-empty__preview > header small {
  color: #8b789a;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
}

.resource-editor-empty__preview > header strong {
  color: #39433c;
  font-size: 12px;
}

.resource-editor-empty__preview > header em {
  border-radius: 999px;
  background: #f0ebf5;
  padding: 5px 8px;
  color: #735d85;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.resource-editor-empty__preview ol {
  display: grid;
  margin: 0;
  padding: 0;
  list-style: none;
}

.resource-editor-empty__preview ol li {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto;
  align-items: center;
  gap: 11px;
  padding: 13px 18px;
}

.resource-editor-empty__preview ol li + li {
  border-top: 1px solid #edf0ed;
}

.resource-editor-empty__preview ol b {
  display: grid;
  width: 26px;
  height: 26px;
  place-items: center;
  border-radius: 8px;
  background: #f3eef8;
  color: #745e87;
  font-size: 12px;
}

.resource-editor-empty__preview ol div {
  display: grid;
  gap: 3px;
}

.resource-editor-empty__preview ol strong {
  color: #445047;
  font-size: 12px;
}

.resource-editor-empty__preview ol span {
  color: #8a948d;
  font-size: 12px;
}

.resource-editor-empty__preview ol small {
  border-radius: 999px;
  background: #f5f2f7;
  padding: 5px 7px;
  color: #776a80;
  font-size: 12px;
  font-weight: 700;
}

.resource-editor-empty__preview > footer {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 13px 18px;
  border-top: 1px solid #e8ece9;
  background: #fafbf9;
}

.resource-editor-empty__preview > footer span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 999px;
  background: #eef3ef;
  padding: 6px 8px;
  color: #5f6d63;
  font-size: 12px;
  font-weight: 700;
}

.resource-editor-empty__preview > footer i {
  color: #6d8774;
}

.resource-editor-diff {
  margin: 24px 32px 0;
  border: 1px solid #f0c3a9;
  border-radius: 15px;
  background: #fff9f4;
  padding: 18px;
}

.resource-editor-diff > header {
  display: flex;
  align-items: center;
  gap: 11px;
}

.resource-editor-diff > header > span {
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  border-radius: 10px;
  background: #ffeadc;
  color: #ed6038;
}

.resource-editor-diff small {
  color: #af775f;
  font-size: 12px;
  font-weight: 700;
}

.resource-editor-diff h3 {
  margin: 2px 0 0;
  font-size: 14px;
}

.resource-editor-diff > header em {
  margin-left: auto;
  border-radius: 999px;
  background: #fff0e5;
  padding: 5px 8px;
  color: #be684b;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.resource-editor-diff > p {
  margin: 13px 0;
  color: #695a52;
  font-size: 12px;
  line-height: 1.6;
}

.resource-editor-diff__summary {
  display: flex;
  gap: 8px;
}

.resource-editor-diff__summary span {
  border-radius: 7px;
  padding: 5px 8px;
  font-size: 12px;
  font-weight: 700;
}

.resource-editor-diff__summary .is-added {
  background: #eaf6ed;
  color: #397049;
}

.resource-editor-diff__summary .is-removed {
  background: #faeaea;
  color: #9a4b4b;
}

.resource-editor-diff__complete {
  margin-top: 12px;
}

.resource-editor-diff__complete > small {
  color: #806f66;
  font-size: 12px;
  font-weight: 700;
}

.resource-editor-diff__complete ol {
  display: grid;
  max-height: 300px;
  gap: 5px;
  overflow-y: auto;
  margin: 7px 0 0;
  padding: 0;
  list-style: none;
}

.resource-editor-diff__complete li {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr) auto;
  align-items: start;
  gap: 8px;
  border: 1px solid #ece6e1;
  border-radius: 8px;
  background: #fff;
  padding: 8px 9px;
  color: #5f5c57;
  font-size: 12px;
  line-height: 1.5;
}

.resource-editor-diff__complete li > b {
  display: grid;
  width: 22px;
  height: 22px;
  place-items: center;
  border-radius: 6px;
  background: #f2f3f1;
  color: #7a817c;
  font-size: 12px;
}

.resource-editor-diff__complete li > span {
  padding-top: 4px;
}

.resource-editor-diff__complete li > em {
  margin-top: 2px;
  border-radius: 999px;
  background: #eaf6ed;
  padding: 3px 6px;
  color: #397049;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.resource-editor-diff__complete li.is-added {
  border-color: #b9ddc2;
  background: #f5fbf6;
}

.resource-editor-diff__complete li.is-added > b {
  background: #dff1e4;
  color: #397049;
}

.resource-editor-diff__list {
  display: grid;
  max-height: 220px;
  gap: 6px;
  overflow-y: auto;
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
}

.resource-editor-diff__list li {
  display: grid;
  grid-template-columns: 62px minmax(0, 1fr);
  gap: 8px;
  border-radius: 8px;
  background: #fff;
  padding: 9px 10px;
  color: #5f5c57;
  font-size: 12px;
  line-height: 1.5;
}

.resource-editor-diff__list li b {
  color: #8a7368;
  font-size: 12px;
}

.resource-editor-diff__list li.is-added b {
  color: #397049;
}

.resource-editor-diff__list li.is-removed b {
  color: #9a4b4b;
}

.resource-editor-diff__list li span {
  display: grid;
  gap: 3px;
}

.resource-editor-diff__list li strong {
  color: #4a4d49;
  font-size: 12px;
}

.resource-editor-diff__list li small {
  color: #7a817c;
  font-size: 12px;
}

.resource-editor-diff__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
}

.resource-editor-diff__actions button {
  border: 1px solid #d8ddd9;
  background: #fff;
  padding: 8px 12px;
  color: #68736c;
}

.resource-editor-diff__actions .is-primary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-color: #ef6038;
  background: #ef6038;
  color: #fff;
}

.resource-editor-chat {
  display: grid;
  grid-template-rows: auto auto minmax(0, 1fr) auto auto auto;
}

.resource-editor-chat__header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px 20px 16px;
}

.resource-editor-chat__header > span {
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  border-radius: 11px;
  background: #fff0e8;
  color: #ed6038;
}

.resource-editor-chat__header h2,
.resource-editor-chat__header p {
  margin: 0;
}

.resource-editor-chat__header h2 {
  font-size: 14px;
}

.resource-editor-chat__header p {
  margin-top: 2px;
  color: #8c9690;
  font-size: 12px;
}

.resource-editor-chat__header em {
  margin-left: auto;
  color: #5f8b6b;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.resource-editor-chat__header em::before {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-right: 5px;
  border-radius: 50%;
  background: #66a273;
  content: "";
}

.resource-editor-chat__context {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 0 20px 15px;
  border-bottom: 1px solid #e8ece9;
}

.resource-editor-chat__context span {
  display: inline-flex;
  min-width: 0;
  align-items: center;
  gap: 5px;
  overflow: hidden;
  border-radius: 999px;
  background: #f2f5f2;
  padding: 6px 9px;
  color: #667169;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.resource-editor-chat__messages {
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 20px;
  scrollbar-gutter: stable;
}

.resource-editor-message {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 16px;
}

.resource-editor-message.is-user {
  justify-content: flex-end;
}

.resource-editor-message__avatar {
  display: grid;
  width: 26px;
  height: 26px;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 8px;
  background: #fff0e8;
  color: #ed6038;
  font-size: 12px;
}

.resource-editor-message > div {
  max-width: 85%;
  border-radius: 5px 14px 14px 14px;
  background: #f3f5f3;
  padding: 11px 13px;
}

.resource-editor-message.is-user > div {
  border-radius: 14px 5px 14px 14px;
  background: #33423a;
  color: #fff;
}

.resource-editor-message.is-system > div {
  background: #edf7ef;
  color: #376147;
}

.resource-editor-message strong {
  font-size: 12px;
}

.resource-editor-message p {
  margin: 3px 0 0;
  white-space: pre-wrap;
  font-size: 12px;
  line-height: 1.6;
}

.resource-editor-message__proposal {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
  border: 1px solid #f1c7b4;
  background: #fff;
  padding: 9px;
  color: #a75a3e;
}

.resource-editor-message__proposal span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.resource-editor-message__proposal strong {
  color: #ed6038;
}

.resource-editor-message__download {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 9px;
  border: 1px solid #d8e1da;
  border-radius: 8px;
  background: #fff;
  padding: 8px 10px;
  color: #42664c;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
}

.resource-editor-message__download:hover {
  border-color: #8ca794;
  background: #f5faf6;
}

.resource-editor-message__files {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 8px;
}

.resource-editor-message__files span {
  display: inline-flex;
  max-width: 230px;
  align-items: center;
  gap: 5px;
  overflow: hidden;
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.14);
  padding: 5px 7px;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.resource-editor-message.is-loading > div {
  display: flex;
  gap: 4px;
  padding: 13px;
}

.resource-editor-message.is-loading > div span {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #96a19a;
  animation: editor-pulse 1s ease-in-out infinite;
}

.resource-editor-message.is-loading > div span:nth-child(2) {
  animation-delay: 0.15s;
}

.resource-editor-message.is-loading > div span:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes editor-pulse {
  0%, 100% {
    opacity: 0.3;
    transform: translateY(0);
  }
  50% {
    opacity: 1;
    transform: translateY(-2px);
  }
}
.resource-editor-chat__suggestions {
  display: grid;
  gap: 6px;
  padding: 0 20px 14px;
}

.resource-editor-chat__suggestions small {
  color: #929c95;
  font-size: 12px;
}

.resource-editor-chat__suggestions button {
  width: 100%;
  border: 1px solid #e1e6e2;
  background: #fff;
  padding: 8px 10px;
  color: #59655d;
  text-align: left;
}

.resource-editor-chat__suggestions button:hover {
  border-color: #efb79f;
  background: #fff9f6;
  color: #b55334;
}

.resource-editor-chat__error {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin: 0 20px 10px;
  border-radius: 9px;
  background: #fff1f1;
  padding: 9px 10px;
  color: #9b4949;
  font-size: 12px;
}

.resource-editor-chat__composer {
  margin: 0 14px 14px;
  border: 1px solid #dbe1dc;
  border-radius: 14px;
  background: #fff;
  padding: 10px;
  box-shadow: 0 4px 18px rgba(35, 50, 41, 0.06);
}

.resource-editor-chat__composer:focus-within {
  border-color: #ef9d7f;
  box-shadow: 0 0 0 3px rgba(239, 96, 56, 0.08);
}

.resource-editor-chat__composer textarea {
  width: 100%;
  min-height: 56px;
  resize: none;
  border: 0;
  outline: 0;
  background: transparent;
  color: #2e3932;
  font: inherit;
  font-size: 12px;
  line-height: 1.55;
}

.resource-editor-chat__composer footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.resource-editor-chat__composer footer > div {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
}

.resource-editor-chat__composer footer span {
  color: #a0a8a2;
  font-size: 12px;
}

.resource-editor-chat__composer button {
  display: grid;
  width: 30px;
  height: 30px;
  place-items: center;
  border: 0;
  background: #ef6038;
  color: #fff;
}

.resource-editor-chat__composer button:disabled {
  background: #d9ded9;
  cursor: not-allowed;
}

.resource-editor-chat__attach {
  display: grid;
  width: 30px;
  height: 30px;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 9px;
  color: #6f7d74;
  cursor: pointer;
}

.resource-editor-chat__attach:hover {
  background: #f2f5f2;
  color: #476a52;
}

.resource-editor-chat__attach.is-loading {
  cursor: wait;
}

.resource-editor-chat__attach input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}

.resource-editor-chat__attachments {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 7px;
}

.resource-editor-chat__attachments > span {
  display: inline-flex;
  max-width: 100%;
  height: 29px;
  align-items: center;
  gap: 6px;
  border: 1px solid #d8dfda;
  border-radius: 8px;
  background: #f6f8f6;
  padding: 0 5px 0 9px;
  color: #526158;
  font-size: 12px;
}

.resource-editor-chat__attachments em {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-style: normal;
}

.resource-editor-chat__attachments button {
  width: 20px;
  height: 20px;
  background: transparent;
  color: #78857c;
}

.resource-editor-chat__attachments button:hover {
  background: #e9eeea;
  color: #4c5d52;
}

.resource-editor-content__empty {
  border: 1px dashed #dfe5e0;
  border-radius: 12px;
  padding: 28px;
  color: #8d9790;
  font-size: 12px;
  text-align: center;
}

.resource-editor-state {
  display: grid;
  min-height: 70vh;
  place-items: center;
  align-content: center;
  gap: 12px;
  color: #6b776e;
}

.resource-editor-state i {
  font-size: 22px;
}

.resource-editor-state button {
  border: 0;
  background: #34463b;
  padding: 9px 13px;
  color: #fff;
}

.resource-editor-state.is-error i {
  color: #b85a4c;
}

@media (max-width: 1120px) {
  .resource-editor-page {
    padding: 18px;
  }
  .resource-editor-layout {
    grid-template-columns: minmax(0, 1.35fr) minmax(330px, 0.8fr);
  }
}
@media (max-width: 820px) {
  .resource-editor-page {
    padding: 12px;
  }
  .resource-editor-layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: minmax(0, 0.8fr) minmax(0, 1.2fr);
    height: auto;
    min-height: 0;
  }
  .resource-editor-document,
  .resource-editor-chat {
    min-height: 0;
  }
  .resource-editor-back {
    width: auto;
    min-height: 40px;
    padding: 0 10px;
  }
  .resource-editor-back__label {
    display: none;
  }
  .resource-editor-back__short-label {
    display: inline;
    white-space: nowrap;
  }
  .resource-editor-topbar__title {
    gap: 9px;
    padding-left: 10px;
  }
  .resource-editor-topbar__icon {
    width: 36px;
    height: 36px;
    border-radius: 11px;
  }
  .resource-editor-topbar__title p {
    font-size: 12px;
  }
  .resource-editor-topbar__context {
    display: none;
  }
  .resource-editor-document__header {
    align-items: stretch;
    flex-direction: column;
    padding: 22px 20px;
  }
  .resource-editor-document__actions,
  .resource-editor-version {
    width: 100%;
    min-width: 0;
  }
  .resource-editor-template-picker {
    grid-template-columns: 1fr;
    gap: 14px;
    padding: 17px 20px;
  }
  .resource-editor-template-picker__control {
    grid-template-columns: 1fr;
  }
  .resource-editor-template-lock {
    margin: 16px 20px 0;
  }
  .resource-editor-content {
    padding: 24px 20px 32px;
  }
  .resource-editor-document__meta {
    padding: 12px 20px;
  }
  .resource-editor-empty {
    margin: 36px auto;
    padding: 0 20px;
  }
  .resource-editor-empty__preview ol li {
    grid-template-columns: 28px minmax(0, 1fr);
    padding: 12px 14px;
  }
  .resource-editor-empty__preview ol small {
    display: none;
  }
  .resource-editor-diff {
    margin: 18px 20px 0;
  }
  .resource-editor-survey-result {
    padding: 0 20px 32px;
  }
  .resource-editor-survey-result > header {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }
  .resource-editor-survey-result__form > section {
    grid-template-columns: 1fr;
  }
  .resource-editor-survey-result__form > section > small {
    border-bottom: 1px solid #edf0ed;
    padding: 10px 13px;
  }
  .resource-editor-survey-result__comments article {
    grid-template-columns: 1fr;
  }
  .resource-editor-survey-result__comments span {
    min-height: 46px;
    border-top: 1px solid #edf0ed;
    border-left: 0;
  }
  .resource-editor-chat__header {
    padding: 14px 14px 10px;
  }
  .resource-editor-chat__context {
    flex-wrap: nowrap;
    padding: 0 14px 10px;
    overflow-x: auto;
    scrollbar-width: none;
  }
  .resource-editor-chat__context::-webkit-scrollbar {
    display: none;
  }
  .resource-editor-chat__messages {
    padding: 12px 14px;
  }
  .resource-editor-chat__suggestions {
    display: flex;
    gap: 6px;
    padding: 0 14px 9px;
    overflow-x: auto;
    scrollbar-width: none;
  }
  .resource-editor-chat__suggestions::-webkit-scrollbar {
    display: none;
  }
  .resource-editor-chat__suggestions small {
    display: none;
  }
  .resource-editor-chat__suggestions button {
    width: auto;
    flex: 0 0 auto;
    white-space: nowrap;
  }
  .resource-editor-chat__composer {
    margin: 0 10px 10px;
    padding: 8px;
  }
  .resource-editor-chat__composer textarea {
    min-height: 40px;
  }
}
/* 11: workspace information hierarchy and shared component roles. */
:host-context(.reviewops-shell) .resource-editor-page .resource-editor-layout {
  min-height: 0;
  gap: 24px;
  padding: 24px var(--ro-gutter);
}
:host-context(.reviewops-shell) .resource-editor-page .resource-editor-topbar__title > span {
  display: none;
}
:host-context(.reviewops-shell) .resource-editor-page .resource-editor-document__header {
  gap: 16px;
  flex-wrap: wrap;
}
:host-context(.reviewops-shell) .resource-editor-page .resource-editor-content {
  font-size: 16px;
  line-height: 28px;
}
:host-context(.reviewops-shell) .resource-editor-page .resource-editor-chat__composer textarea {
  width: 100%;
}
@media (max-width: 1023px) {
  :host-context(.reviewops-shell) .resource-editor-page {
    height: auto;
    overflow: visible;
  }
  :host-context(.reviewops-shell) .resource-editor-page .resource-editor-layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    height: auto;
  }
  :host-context(.reviewops-shell) .resource-editor-page .resource-editor-document, :host-context(.reviewops-shell) .resource-editor-page .resource-editor-chat {
    height: auto;
    max-height: none;
    overflow: visible;
  }
  :host-context(.reviewops-shell) .resource-editor-page .resource-editor-document__body, :host-context(.reviewops-shell) .resource-editor-page .resource-editor-chat__messages {
    max-height: none;
    overflow: visible;
  }
}

:host-context(.reviewops-shell) .resource-editor-page {
  padding: 0;
  gap: 0;
}
:host-context(.reviewops-shell) .resource-editor-page .resource-editor-pane-switch {
  display: none;
}
@media (max-width: 1023px) {
  :host-context(.reviewops-shell) .resource-editor-page {
    grid-template-rows: auto auto auto;
  }
  :host-context(.reviewops-shell) .resource-editor-page .resource-editor-pane-switch {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 16px var(--ro-gutter) 0;
  }
  :host-context(.reviewops-shell) .resource-editor-page .resource-editor-pane-switch button {
    background: white;
    border: 1px solid var(--ro-control);
  }
  :host-context(.reviewops-shell) .resource-editor-page .resource-editor-pane-switch [aria-pressed=true] {
    color: #8F351D;
    background: #FFF0ED;
    border-color: var(--ro-accent);
  }
  :host-context(.reviewops-shell) .resource-editor-page .ro-pane-inactive {
    display: none;
  }
}`],
})
export class PageProjectResourceEditorComponent implements OnInit {
    public workspacePane: 'document' | 'request' = 'document';
    public projectId: string = '';
    public resourceId: string = '';
    public kind: 'harness' | 'survey' = 'harness';
    public project: any = null;
    public resource: any = null;
    public workspace: any = null;
    public selectedVersion: string = '';
    public loading: boolean = true;
    public loadError: string = '';
    public message: string = '';
    public asking: boolean = false;
    public actionId: string = '';
    public errorMessage: string = '';
    public exchanges: any[] = [];
    public pendingProposal: any = null;
    public conversationId: string = '';
    public attachments: any[] = [];
    public uploadingFile: boolean = false;
    public commonHarnessRegistering: boolean = false;
    public selectedCommonHarnessId: string = '';
    public commonHarnessApplying: boolean = false;
    public commonSurveyRegistering: boolean = false;
    public selectedCommonSurveyId: string = '';
    public commonSurveyApplying: boolean = false;
    private readonly stateUrl: string = '/api/v1/review-workspace/state';
    private readonly operatorUrl: string = '/api/v1/review-workspace/operator';
    private readonly managementUrl: string = '/api/v1/review-workspace/management';

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.role('admin', '/access');
        this.projectId = String(WizRoute.segment.projectId || '');
        this.resourceId = String(WizRoute.segment.resourceId || 'new');
        this.kind = WizRoute.segment.kind === 'survey' ? 'survey' : 'harness';
        this.conversationId = this.createConversationId();
        await this.loadWorkspace();
        await this.adoptConfiguredProjectResource();
        this.restoreConversationFromWorkspace();
        await this.service.render();
        this.scrollConversation();
    }

    public get isCreateMode() {
        return this.resourceId === 'new';
    }

    public kindLabel() {
        return this.kind === 'harness' ? '하네스' : '설문지';
    }

    public kindDescription() {
        return this.kind === 'harness'
            ? 'QA 생성 형식과 품질을 결정하는 규칙을 확인하고 수정합니다.'
            : '생성 결과를 사람이 검수할 때 사용할 평가 문항을 확인하고 수정합니다.';
    }

    public commonHarnesses() {
        if (this.kind !== 'harness' || !Array.isArray(this.workspace?.harnesses)) return [];
        return this.workspace.harnesses.filter((item: any) => (
            item?.adminDesignated === true
            || item?.admin_designated === true
            || item?.catalogVisible === true
            || item?.catalog_visible === true
        ));
    }

    public commonSurveys() {
        if (this.kind !== 'survey' || !Array.isArray(this.workspace?.surveys)) return [];
        return this.workspace.surveys.filter((item: any) => (
            item?.adminDesignated === true
            || item?.admin_designated === true
            || item?.catalogVisible === true
            || item?.catalog_visible === true
        ));
    }

    public isCommonHarnessApplied() {
        return !!this.selectedCommonHarnessId
            && String(this.resource?.templateHarnessId || '') === this.selectedCommonHarnessId;
    }

    public isCommonHarnessOriginal() {
        return this.kind === 'harness' && !!this.resource && this.isCommonHarness();
    }

    public isCommonSurveyApplied() {
        return !!this.selectedCommonSurveyId
            && String(this.resource?.templateSurveyId || '') === this.selectedCommonSurveyId;
    }

    public isCommonSurveyOriginal() {
        return this.kind === 'survey' && !!this.resource && this.isCommonSurveyResource();
    }

    public isCommonResourceOriginal() {
        return this.isCommonHarnessOriginal() || this.isCommonSurveyOriginal();
    }

    public commonHarnessPickerDescription() {
        if (!this.commonHarnesses().length) return '현재 사용할 수 있는 공통 하네스가 없습니다. 오른쪽 채팅에서 처음부터 만들 수 있습니다.';
        if (!this.selectedCommonHarnessId) return '공통 하네스를 사용하지 않고 오른쪽 채팅에서 처음부터 만들 수 있습니다.';
        if (this.isCommonHarnessApplied()) return '공통 원본에서 복제된 프로젝트 전용 하네스입니다. 이 프로젝트에서 자유롭게 수정할 수 있습니다.';
        return '선택한 공통 하네스의 규칙을 복제해 이 프로젝트만의 하네스를 만듭니다.';
    }

    public commonSurveyPickerDescription() {
        if (!this.commonSurveys().length) return '현재 사용할 수 있는 공통 설문지가 없습니다. 오른쪽 채팅에서 처음부터 만들 수 있습니다.';
        if (!this.selectedCommonSurveyId) return '공통 설문지를 사용하지 않고 오른쪽 채팅에서 처음부터 만들 수 있습니다.';
        if (this.isCommonSurveyApplied()) return '공통 원본에서 복제된 프로젝트 전용 설문지입니다. 이 프로젝트에서 자유롭게 수정할 수 있습니다.';
        return '선택한 공통 설문지의 문항을 복제해 이 프로젝트만의 설문지를 만듭니다.';
    }

    public async applyCommonHarness() {
        if (
            this.kind !== 'harness'
            || this.commonHarnessApplying
            || this.isCommonHarnessApplied()
        ) return;
        if (!this.selectedCommonHarnessId) {
            if (this.isCreateMode) return;
            this.resourceId = 'new';
            this.resource = null;
            this.selectedVersion = '';
            this.conversationId = this.createConversationId();
            this.exchanges = [];
            this.pendingProposal = null;
            this.attachments = [];
            this.errorMessage = '';
            await this.router.navigate(
                ['/review-projects', this.projectId, 'resource-editor', 'harness', 'new'],
                { replaceUrl: true }
            );
            await this.service.render();
            return;
        }
        this.commonHarnessApplying = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const source = this.commonHarnesses().find((item: any) => String(item?.id || '') === this.selectedCommonHarnessId);
            if (!source) throw new Error('선택한 공통 하네스를 찾을 수 없습니다.');
            const result = await this.mutateWorkspace({
                resource: 'harnesses',
                action: 'clone',
                id: source.id,
                project_id: this.projectId,
                setting_kind: 'qa'
            });
            const state = this.normalizeWorkspaceState(result.state);
            if (!state || !result.item?.id) throw new Error('프로젝트 전용 하네스 생성 응답이 올바르지 않습니다.');
            this.workspace = state;
            this.project = state.projects.find((item: any) => String(item?.id || '') === this.projectId) || result.project || this.project;
            this.resource = result.item;
            this.resourceId = String(result.item.id);
            this.selectedCommonHarnessId = String(result.item.templateHarnessId || source.id);
            const active = this.versions().find((item: any) => item?.active === true);
            this.selectedVersion = String(active?.version || active?.id || this.resourceVersion() || '');
            this.conversationId = this.createConversationId();
            this.exchanges = [];
            this.pendingProposal = null;
            await this.router.navigate(
                ['/review-projects', this.projectId, 'resource-editor', 'harness', this.resourceId],
                { replaceUrl: true }
            );
            window.dispatchEvent(new CustomEvent('reviewops:project-resource-updated', {
                detail: { kind: 'harness', project_id: this.projectId, resource_id: this.resourceId }
            }));
            await this.service.modal.success(`'${source.name}'을 바탕으로 프로젝트 전용 하네스를 만들었습니다.`);
        } catch (error) {
            this.errorMessage = error instanceof Error ? error.message : '공통 하네스를 적용하지 못했습니다.';
        } finally {
            this.commonHarnessApplying = false;
            await this.service.render();
        }
    }

    public async applyCommonSurvey() {
        if (
            this.kind !== 'survey'
            || this.commonSurveyApplying
            || this.isCommonSurveyApplied()
        ) return;
        if (!this.selectedCommonSurveyId) {
            if (this.isCreateMode) return;
            this.resourceId = 'new';
            this.resource = null;
            this.selectedVersion = '';
            this.conversationId = this.createConversationId();
            this.exchanges = [];
            this.pendingProposal = null;
            this.attachments = [];
            this.errorMessage = '';
            await this.router.navigate(
                ['/review-projects', this.projectId, 'resource-editor', 'survey', 'new'],
                { replaceUrl: true }
            );
            await this.service.render();
            return;
        }
        this.commonSurveyApplying = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const source = this.commonSurveys().find((item: any) => String(item?.id || '') === this.selectedCommonSurveyId);
            if (!source) throw new Error('선택한 공통 설문지를 찾을 수 없습니다.');
            const result = await this.mutateWorkspace({
                resource: 'surveys',
                action: 'clone',
                id: source.id,
                project_id: this.projectId,
                setting_kind: 'qa'
            });
            const state = this.normalizeWorkspaceState(result.state);
            if (!state || !result.item?.id) throw new Error('프로젝트 전용 설문지 생성 응답이 올바르지 않습니다.');
            this.workspace = state;
            this.project = state.projects.find((item: any) => String(item?.id || '') === this.projectId) || result.project || this.project;
            this.resource = result.item;
            this.resourceId = String(result.item.id);
            this.selectedCommonSurveyId = String(result.item.templateSurveyId || source.id);
            const active = this.versions().find((item: any) => item?.active === true);
            this.selectedVersion = String(active?.version || active?.id || this.resourceVersion() || '');
            this.conversationId = this.createConversationId();
            this.exchanges = [];
            this.pendingProposal = null;
            await this.router.navigate(
                ['/review-projects', this.projectId, 'resource-editor', 'survey', this.resourceId],
                { replaceUrl: true }
            );
            window.dispatchEvent(new CustomEvent('reviewops:project-resource-updated', {
                detail: { kind: 'survey', project_id: this.projectId, resource_id: this.resourceId }
            }));
            await this.service.modal.success(`'${source.name}'을 바탕으로 프로젝트 전용 설문지를 만들었습니다.`);
        } catch (error) {
            this.errorMessage = error instanceof Error ? error.message : '공통 설문지를 적용하지 못했습니다.';
        } finally {
            this.commonSurveyApplying = false;
            await this.service.render();
        }
    }

    public resourceVersion() {
        return String(this.resource?.activeVersion || this.resource?.active_version || this.resource?.version || this.selectedVersion || '');
    }

    public resourceDateLabel() {
        const raw = String(
            this.snapshot()?.date || this.resource?.updated || this.resource?.created || ''
        ).trim();
        if (!raw) return '등록일 정보 없음';
        const dateOnly = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (dateOnly) return `${dateOnly[1]}. ${dateOnly[2]}. ${dateOnly[3]}.`;
        const parsed = new Date(raw);
        if (Number.isNaN(parsed.getTime())) return raw.replace('T', ' ').replace(/\.\d+Z$/, '');
        const pad = (value: number) => String(value).padStart(2, '0');
        return `${parsed.getFullYear()}. ${pad(parsed.getMonth() + 1)}. ${pad(parsed.getDate())}. ${pad(parsed.getHours())}:${pad(parsed.getMinutes())}`;
    }

    public versions() {
        const versions = Array.isArray(this.resource?.versions)
            ? this.resource.versions.filter((version: any) => version && typeof version === 'object')
            : [];
        if (versions.length) return [...versions].reverse();
        return this.resource ? [{ version: this.resourceVersion(), active: true }] : [];
    }

    public versionLabel(version: any) {
        const label = String(version?.version || version?.id || '버전 정보 없음');
        return version?.active === true || label === this.resourceVersion() ? `${label} · 현재 사용 중` : label;
    }

    public snapshot() {
        if (!this.resource) return null;
        const version = this.versions().find((item: any) => {
            return String(item?.version || item?.id || '') === String(this.selectedVersion || '');
        });
        if (!version) return this.resource;
        const name = String(version?.version || version?.id || '');
        return version?.active === true || name === this.resourceVersion()
            ? { ...this.resource, ...version }
            : version;
    }

    public rules() {
        const rows = this.snapshot()?.rules;
        return Array.isArray(rows) ? rows.map((item: any) => String(item || '').trim()).filter(Boolean) : [];
    }

    public questions() {
        const snapshot = this.snapshot();
        const rows = Array.isArray(snapshot?.dimensions)
            ? snapshot.dimensions
            : (Array.isArray(snapshot?.questionItems) ? snapshot.questionItems : []);
        return rows.filter((item: any) => item && typeof item === 'object');
    }

    public decisionOptions() {
        const rows = this.snapshot()?.decisionOptions;
        return Array.isArray(rows) ? rows : [];
    }

    public issueOptions() {
        const rows = this.snapshot()?.issueOptions;
        return Array.isArray(rows) ? rows.filter((item: any) => item && typeof item === 'object') : [];
    }

    public commentFields() {
        const rows = this.snapshot()?.commentFields;
        return Array.isArray(rows) ? rows : [];
    }

    public optionLabel(option: any) {
        if (option && typeof option === 'object') {
            const label = String(option.label || option.text || option.value || '').trim();
            return option.score !== undefined && option.score !== null
                ? `${option.score}점${label ? ' · ' + label : ''}`
                : label;
        }
        return String(option || '').trim();
    }

    public issueLabel(issue: any) {
        const code = String(issue?.code || issue?.value || '').trim();
        const label = String(issue?.label || issue?.text || '').trim();
        return label || code;
    }

    public suggestedPrompts() {
        if (this.isCreateMode) {
            return this.kind === 'harness'
                ? ['이 프로젝트 자료에 맞는 하네스를 만들어줘', '원문 인용 정확성과 중복 방지를 강화해서 만들어줘']
                : ['QA 검수용 1~5점 설문지를 만들어줘', '근거 정확성과 질문 품질을 따로 평가하게 만들어줘'];
        }
        return this.kind === 'harness'
            ? ['추론형 질문을 금지하는 규칙을 추가해줘', '중복되는 규칙을 정리해줘', '원문 인용 검증을 더 엄격하게 해줘']
            : ['사유 선택지를 검수자가 이해하기 쉬운 한국어 문구로 바꿔줘', '근거 적절성 문항을 보강해줘', '겹치는 문항을 정리해줘', '최종 수정 의견란을 추가해줘'];
    }

    public async usePrompt(prompt: string) {
        this.message = prompt;
        await this.service.render();
        requestAnimationFrame(() => (document.querySelector('.resource-editor-chat__composer textarea') as HTMLTextAreaElement)?.focus());
    }

    public onComposerKeydown(event: KeyboardEvent) {
        if (event.key !== 'Enter' || event.shiftKey || event.isComposing || event.keyCode === 229) return;
        event.preventDefault();
        void this.ask();
    }

    public async uploadAttachment(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        input.value = '';
        if (!file || this.uploadingFile || this.attachments.length >= 1 || this.isCommonResourceOriginal()) return;
        this.uploadingFile = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const body = new FormData();
            body.set('file', file);
            const response = await fetch('/api/v1/review-workspace/operator-file', {
                method: 'POST', credentials: 'same-origin', cache: 'no-store',
                headers: { Accept: 'application/json' }, body
            });
            const payload = await this.readPayload(response);
            if (!response.ok) {
                throw new Error(payload?.message || payload?.data?.message || '파일을 업로드하지 못했습니다.');
            }
            const attachment = this.unwrap(payload);
            if (!attachment?.id) throw new Error('업로드한 파일 정보를 확인하지 못했습니다.');
            this.attachments = [attachment];
        } catch (error: any) {
            this.errorMessage = error?.message || '파일을 업로드하지 못했습니다.';
        } finally {
            this.uploadingFile = false;
            await this.service.render();
        }
    }

    public async removeAttachment(attachmentId: string) {
        this.attachments = this.attachments.filter((item: any) => item?.id !== attachmentId);
        await this.service.render();
    }

    public async ask() {
        const value = String(this.message || '').trim();
        const requestAttachments = this.attachments.map((item: any) => ({ ...item }));
        if (this.isCommonResourceOriginal()) {
            this.errorMessage = this.kind === 'harness'
                ? '공통 하네스 원본은 수정할 수 없습니다. 공통 하네스를 프로젝트 전용으로 복제하거나 처음부터 새로 만들어주세요.'
                : '공통 설문지 원본은 수정할 수 없습니다. 공통 설문지를 프로젝트 전용으로 복제하거나 처음부터 새로 만들어주세요.';
            await this.service.render();
            return;
        }
        if ((!value && !requestAttachments.length) || this.asking) return;
        const displayedMessage = value || `첨부한 파일을 ${this.kindLabel()}로 업로드해줘.`;
        this.message = '';
        this.attachments = [];
        this.errorMessage = '';
        this.exchanges.push({
            role: 'user', text: displayedMessage, attachments: requestAttachments,
            createdAt: new Date().toISOString()
        });
        this.asking = true;
        await this.service.render();
        this.scrollConversation();
        try {
            const requestMessage = requestAttachments.length
                ? (this.isCreateMode
                    ? `이 프로젝트에 ${this.kindLabel()}를 새로 생성하고 첨부 파일을 ${this.kindLabel()}로 업로드해줘. 사용자의 세부 요구: ${displayedMessage}`
                    : `현재 ${this.kindLabel()}에 첨부 파일을 새 버전으로 업로드해줘. 사용자의 세부 요구: ${displayedMessage}`)
                : (this.isCreateMode
                    ? `이 프로젝트에 ${this.kindLabel()}를 새로 생성해줘. 사용자의 세부 요구: ${displayedMessage}`
                    : displayedMessage);
            const result = await this.post({
                action: 'ask',
                message: requestMessage,
                project_id: this.projectId,
                harness_id: this.kind === 'harness' && !this.isCreateMode ? this.resourceId : '',
                survey_id: this.kind === 'survey' && !this.isCreateMode ? this.resourceId : '',
                // This screen always works on a concrete resource (or creates one).
                // Exclude development-request classification, which can mistake
                // survey labels such as reason codes for a software change request.
                request_type: 'execute',
                conversation_id: this.conversationId,
                page_context: this.kind === 'harness' ? 'harness_management' : 'survey_management',
                attachment_ids: requestAttachments.map((item: any) => item.id)
            });
            if (!result?.answer) throw new Error('운영 도우미가 답변을 반환하지 않았습니다.');
            this.conversationId = String(result.conversation_id || this.conversationId);
            this.exchanges.push({
                role: 'assistant',
                text: result.answer,
                proposal: result.proposal || null,
                directAction: result.direct_action || null,
                createdAt: result.created_at || new Date().toISOString()
            });
            if (result?.proposal?.status === 'pending') {
                this.pendingProposal = result.proposal;
                if (this.shouldAutoApplyResourceChange(result.proposal)) {
                    await this.proposalAction('apply');
                }
            }
            const directActionKind = String(result?.direct_action?.kind || '');
            const completedResourceActions = this.kind === 'harness'
                ? ['harness_creation', 'harness_connection', 'harness_upload']
                : ['survey_creation', 'survey_connection', 'survey_upload'];
            const createdId = completedResourceActions.includes(directActionKind)
                ? String(result?.direct_action?.target_id || '')
                : '';
            if (this.isCreateMode && createdId) {
                this.resourceId = createdId;
                await this.loadWorkspace(createdId);
                await this.router.navigate(['/review-projects', this.projectId, 'resource-editor', this.kind, createdId], { replaceUrl: true });
                window.dispatchEvent(new CustomEvent('reviewops:project-resource-updated', {
                    detail: { kind: this.kind, project_id: this.projectId, resource_id: createdId }
                }));
            } else if (
                createdId === this.resourceId
                && ['harness_upload', 'survey_upload'].includes(directActionKind)
            ) {
                await this.loadWorkspace(this.resourceId);
            }
        } catch (error: any) {
            this.errorMessage = error?.message || '요청을 처리하지 못했습니다.';
            if (!this.message) this.message = value;
            if (!this.attachments.length) this.attachments = requestAttachments;
        } finally {
            this.asking = false;
            await this.service.render();
            this.scrollConversation();
        }
    }

    public proposalRules(proposal: any = this.pendingProposal) {
        const rows = proposal?.rules || proposal?.payload?.rules || proposal?.changes?.rules;
        return Array.isArray(rows) ? rows.map((item: any) => String(item || '').trim()).filter(Boolean) : [];
    }

    public proposalQuestions(proposal: any = this.pendingProposal) {
        const direct = proposal?.dimensions || proposal?.questionItems || proposal?.payload?.dimensions;
        if (Array.isArray(direct)) return direct;
        const changes = Array.isArray(proposal?.changes) ? proposal.changes : [];
        for (const change of changes) {
            if (!['dimensions', 'questionItems'].includes(String(change?.field || change?.key || ''))) continue;
            const value = change?.value ?? change?.after;
            if (Array.isArray(value)) return value;
            if (typeof value === 'string') {
                try {
                    const parsed = JSON.parse(value);
                    if (Array.isArray(parsed)) return parsed;
                } catch (error) { }
            }
        }
        return [];
    }

    public proposalAddedRules() {
        const before = new Set(this.rules());
        return this.proposalRules().filter((rule: string) => !before.has(rule));
    }

    public proposalRemovedRules() {
        const after = new Set(this.proposalRules());
        return this.rules().filter((rule: string) => !after.has(rule));
    }

    public proposalSurveyChanges() {
        const changes = Array.isArray(this.pendingProposal?.changes) ? this.pendingProposal.changes : [];
        return changes.map((change: any) => {
            let detail: any = {};
            const raw = change?.value ?? change?.after;
            if (raw && typeof raw === 'object') detail = raw;
            if (typeof raw === 'string') {
                try { detail = JSON.parse(raw); } catch (error) { detail = { label: raw }; }
            }
            return {
                action: String(change?.field || change?.key || ''),
                label: String(detail?.label || detail?.target || detail?.question || raw || '설문 내용 변경'),
                question: String(detail?.question || '')
            };
        });
    }

    public proposalChangeActionLabel(action: string) {
        const labels: Record<string, string> = {
            add_question: '문항 추가', update_question: '문항 수정', remove_question: '문항 삭제',
            add_decision_option: '최종 판정 추가', remove_decision_option: '최종 판정 삭제',
            add_issue_option: '사유 선택지 추가', update_issue_option: '사유 선택지 수정', remove_issue_option: '사유 선택지 삭제',
            add_comment_field: '줄글 항목 추가', remove_comment_field: '줄글 항목 삭제'
        };
        return labels[action] || '내용 변경';
    }

    public proposalSummary(proposal: any = this.pendingProposal) {
        return String(proposal?.summary || proposal?.title || proposal?.description || '요청하신 내용을 반영한 변경안입니다.');
    }

    private shouldAutoApplyResourceChange(proposal: any) {
        if (this.isCreateMode || proposal?.status !== 'pending') return false;
        return (this.kind === 'survey' && proposal?.kind === 'survey_content')
            || (this.kind === 'harness' && proposal?.kind === 'harness_rules');
    }

    public async proposalAction(action: 'apply' | 'dismiss') {
        const proposal = this.pendingProposal;
        if (!proposal?.id || this.actionId) return;
        const wasCreateMode = this.isCreateMode;
        this.actionId = `${proposal.id}:${action}`;
        this.errorMessage = '';
        await this.service.render();
        try {
            const result = await this.post({ action, proposal_id: proposal.id });
            proposal.status = action === 'apply' ? 'applied' : 'dismissed';
            this.exchanges.push({
                role: 'system',
                text: action === 'apply'
                    ? String(result?.answer || `${this.kindLabel()} 변경안을 적용했습니다. 새 버전을 왼쪽에 반영했습니다.`)
                    : '변경안을 반려했습니다. 저장된 내용은 바뀌지 않았습니다.',
                createdAt: new Date().toISOString()
            });
            this.pendingProposal = null;
            if (action === 'apply') {
                const createdId = String(result?.proposal?.target_id || proposal?.target_id || '');
                if (wasCreateMode && createdId) {
                    this.resourceId = createdId;
                    await this.loadWorkspace(createdId);
                    await this.router.navigate(['/review-projects', this.projectId, 'resource-editor', this.kind, createdId], { replaceUrl: true });
                } else {
                    await this.loadWorkspace();
                }
                window.dispatchEvent(new CustomEvent('reviewops:project-resource-updated', {
                    detail: { kind: this.kind, project_id: this.projectId, resource_id: createdId || this.resourceId }
                }));
            }
        } catch (error: any) {
            this.errorMessage = error?.message || '변경안을 처리하지 못했습니다.';
        } finally {
            this.actionId = '';
            await this.service.render();
            this.scrollConversation();
        }
    }

    public backToSettings() {
        void this.router.navigate(['/review-projects', this.projectId, 'settings']);
    }

    public isCommonHarness() {
        return this.resource?.adminDesignated === true
            || this.resource?.admin_designated === true
            || this.resource?.catalogVisible === true
            || this.resource?.catalog_visible === true;
    }

    public isCommonSurvey() {
        if (!this.isCommonSurveyResource()) return false;
        const registeredVersion = this.commonSurveyVersion();
        return !!registeredVersion && registeredVersion === String(this.selectedVersion || this.resourceVersion());
    }

    public isCommonSurveyResource() {
        return this.resource?.adminDesignated === true
            || this.resource?.admin_designated === true
            || this.resource?.catalogVisible === true
            || this.resource?.catalog_visible === true;
    }

    public commonSurveyVersion(resource: any = this.resource) {
        return String(
            resource?.catalogVersion
            || resource?.catalog_version
            || resource?.activeVersion
            || resource?.active_version
            || resource?.version
            || ''
        );
    }

    public async registerCommonHarness() {
        if (this.kind !== 'harness' || !this.resource?.id || this.commonHarnessRegistering || this.isCommonHarness()) return;
        this.commonHarnessRegistering = true;
        await this.service.render();
        try {
            const result = await this.mutateWorkspace({
                resource: 'harnesses',
                action: 'update',
                id: this.resource.id,
                patch: { adminDesignated: true }
            });
            this.resource = result.item || { ...this.resource, adminDesignated: true };
            await this.service.modal.success(`'${this.resource.name}' 하네스를 공통 하네스로 등록했습니다.`);
            await this.router.navigate(['/harnesses']);
        } catch (error) {
            await this.service.modal.warning(
                error instanceof Error ? error.message : '공통 하네스로 등록하지 못했습니다.',
                false,
                '확인'
            );
        } finally {
            this.commonHarnessRegistering = false;
            await this.service.render();
        }
    }

    public async registerCommonSurvey() {
        if (this.kind !== 'survey' || !this.resource?.id || this.commonSurveyRegistering || this.isCommonSurvey()) return;
        const catalogVersion = String(this.selectedVersion || this.resourceVersion() || '').trim();
        if (!catalogVersion) return;
        this.commonSurveyRegistering = true;
        await this.service.render();
        try {
            const result = await this.mutateWorkspace({
                resource: 'surveys',
                action: 'update',
                id: this.resource.id,
                patch: { adminDesignated: true, catalogVersion }
            });
            this.resource = result.item || { ...this.resource, adminDesignated: true, catalogVersion };
            await this.service.modal.success(`'${this.resource.name}' ${catalogVersion} 버전을 공통 설문지로 등록했습니다.`);
            await this.router.navigate(['/surveys']);
        } catch (error) {
            await this.service.modal.warning(
                error instanceof Error ? error.message : '공통 설문지로 등록하지 못했습니다.',
                false,
                '확인'
            );
        } finally {
            this.commonSurveyRegistering = false;
            await this.service.render();
        }
    }

    private async adoptConfiguredProjectResource() {
        if (!this.isCreateMode || !this.project) return;
        const qa = this.project?.settings?.qa || {};
        const configuredId = String(this.kind === 'harness' ? qa?.harnessId || '' : qa?.surveyId || '');
        if (!configuredId) return;
        const collection = this.kind === 'harness' ? this.workspace?.harnesses : this.workspace?.surveys;
        const exists = Array.isArray(collection)
            && collection.some((item: any) => String(item?.id || '') === configuredId);
        if (!exists) return;
        this.resourceId = configuredId;
        await this.loadWorkspace(configuredId);
        await this.router.navigate(
            ['/review-projects', this.projectId, 'resource-editor', this.kind, configuredId],
            { replaceUrl: true }
        );
    }

    private async loadWorkspace(preferredResourceId: string = '') {
        this.loading = true;
        this.loadError = '';
        try {
            const response = await fetch(this.stateUrl, {
                method: 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
            });
            const payload = await this.readPayload(response);
            if (!response.ok) throw new Error('프로젝트 정보를 불러오지 못했습니다.');
            const state = this.normalizeWorkspaceState(payload);
            if (!state) throw new Error('프로젝트 정보 형식이 올바르지 않습니다.');
            this.workspace = state;
            this.project = state.projects.find((item: any) => String(item?.id || '') === this.projectId) || null;
            if (!this.project) throw new Error('프로젝트를 찾을 수 없습니다.');
            const collection = this.kind === 'harness' ? state.harnesses : state.surveys;
            const targetId = String(preferredResourceId || this.resourceId || '');
            this.resource = targetId === 'new'
                ? null
                : collection.find((item: any) => String(item?.id || '') === targetId) || null;
            if (targetId !== 'new' && !this.resource) throw new Error(`${this.kindLabel()}를 찾을 수 없습니다.`);
            if (this.resource) {
                const active = this.versions().find((item: any) => item?.active === true);
                this.selectedVersion = String(active?.version || active?.id || this.resourceVersion() || '');
                this.selectedCommonHarnessId = String(
                    this.resource?.templateHarnessId || (this.isCommonHarness() ? this.resource?.id : '') || ''
                );
                this.selectedCommonSurveyId = String(
                    this.resource?.templateSurveyId || (this.isCommonSurveyResource() ? this.resource?.id : '') || ''
                );
            } else if (this.kind === 'harness') {
                this.selectedCommonHarnessId = '';
            } else {
                this.selectedCommonSurveyId = '';
            }
        } catch (error: any) {
            this.loadError = error?.message || '화면을 불러오지 못했습니다.';
        } finally {
            this.loading = false;
        }
    }

    private normalizeWorkspaceState(payload: any) {
        const candidates = [payload?.data?.data?.state, payload?.data?.state, payload?.data?.data, payload?.result?.state, payload?.state, payload?.result, payload?.data, payload];
        const state = candidates.find((item: any) => item && typeof item === 'object'
            && (Object.prototype.hasOwnProperty.call(item, 'projects') || Object.prototype.hasOwnProperty.call(item, 'harnesses')));
        if (!state) return null;
        const rows = (value: any) => Array.isArray(value) ? value : (value && typeof value === 'object' ? Object.values(value) : []);
        return {
            ...state,
            projects: rows(state.projects),
            harnesses: rows(state.harnesses),
            surveys: rows(state.surveys),
            operator_activity: rows(state.operator_activity),
            operator_proposals: rows(state.operator_proposals)
        };
    }

    private restoreConversationFromWorkspace() {
        if (this.loadError || !this.workspace) return;
        const activity = Array.isArray(this.workspace.operator_activity)
            ? this.workspace.operator_activity
            : [];
        const restorableTypes = new Set([
            'assistant.response',
            'assistant.request_started',
            'assistant.request_failed',
            'assistant.request_cancelled'
        ]);
        const anchor = activity.find((item: any) => (
            restorableTypes.has(String(item?.type || ''))
            && this.activityMatchesCurrentEditor(item)
        ));
        const conversationId = String(anchor?.conversation_id || '');
        if (!conversationId) return;

        const proposals = Array.isArray(this.workspace.operator_proposals)
            ? this.workspace.operator_proposals
            : [];
        const conversationRows = activity.filter((item: any) => (
            restorableTypes.has(String(item?.type || ''))
            && String(item?.conversation_id || '') === conversationId
            && this.activityPageContext(item) === this.editorPageContext()
            && this.activityProjectId(item) === this.projectId
            && this.activityBelongsToProjectLifetime(item)
            && this.activityBelongsToCurrentActor(item)
        )).reverse();
        const exchanges: any[] = [];
        let pendingProposal: any = null;
        for (const item of conversationRows) {
            const request = this.restoredRequestText(item?.request);
            if (request) {
                exchanges.push({
                    role: 'user',
                    text: request,
                    attachments: Array.isArray(item?.attachments) ? item.attachments : [],
                    createdAt: item?.created_at || ''
                });
            }
            if (item?.type === 'assistant.response' && String(item?.answer || '').trim()) {
                const proposal = item?.proposal_id
                    ? proposals.find((candidate: any) => candidate?.id === item.proposal_id) || null
                    : null;
                exchanges.push({
                    role: 'assistant',
                    text: String(item.answer),
                    proposal,
                    directAction: item?.direct_action || null,
                    createdAt: item?.completed_at || item?.created_at || ''
                });
                if (proposal?.status === 'pending') pendingProposal = proposal;
                continue;
            }
            const interruptedMessage: Record<string, string> = {
                'assistant.request_started': '이전 요청의 응답이 완료되지 않았습니다. 필요하면 같은 내용을 다시 보내주세요.',
                'assistant.request_failed': '이전 요청을 처리하지 못했습니다. 필요하면 같은 내용을 다시 보내주세요.',
                'assistant.request_cancelled': '이전 요청이 중지되었습니다.'
            };
            if (interruptedMessage[String(item?.type || '')]) {
                exchanges.push({
                    role: 'system',
                    text: interruptedMessage[String(item.type)],
                    createdAt: item?.completed_at || item?.created_at || ''
                });
            }
        }
        this.conversationId = conversationId;
        this.exchanges = exchanges;
        this.pendingProposal = pendingProposal;
    }

    private activityMatchesCurrentEditor(item: any) {
        if (
            this.activityPageContext(item) !== this.editorPageContext()
            || this.activityProjectId(item) !== this.projectId
            || !this.activityBelongsToProjectLifetime(item)
            || !this.activityBelongsToCurrentActor(item)
        ) return false;
        const resourceId = this.activityResourceId(item);
        return this.isCreateMode ? !resourceId : resourceId === this.resourceId;
    }

    private editorPageContext() {
        return this.kind === 'harness' ? 'harness_management' : 'survey_management';
    }

    private activityPageContext(item: any) {
        return String(item?.page_context || '');
    }

    private activityProjectId(item: any) {
        const context = Array.isArray(item?.request_context) ? item.request_context : [];
        const project = context.find((entry: any) => entry?.kind === 'project' && entry?.selected);
        return String(project?.id || item?.direct_action?.project_id || '');
    }

    private activityBelongsToProjectLifetime(item: any) {
        const projectCreatedAt = Date.parse(String(this.project?.createdAt || ''));
        const activityCreatedAt = Date.parse(String(item?.completed_at || item?.created_at || ''));
        if (!Number.isFinite(projectCreatedAt) || !Number.isFinite(activityCreatedAt)) return true;
        return activityCreatedAt >= projectCreatedAt;
    }

    private activityResourceId(item: any) {
        const context = Array.isArray(item?.request_context) ? item.request_context : [];
        const selected = context.find((entry: any) => entry?.kind === this.kind && entry?.selected);
        if (selected?.id) return String(selected.id);
        const actionKind = String(item?.direct_action?.kind || '');
        const resourceActions = this.kind === 'harness'
            ? ['harness_creation', 'harness_connection', 'harness_upload', 'harness_update', 'harness_rename']
            : ['survey_creation', 'survey_connection', 'survey_upload', 'survey_update', 'survey_rename'];
        return resourceActions.includes(actionKind) ? String(item?.direct_action?.target_id || '') : '';
    }

    private activityBelongsToCurrentActor(item: any) {
        const actor = item?.actor && typeof item.actor === 'object' ? item.actor : {};
        const session = this.service.auth.session || {};
        const keys = ['id', 'email'].filter((key: string) => (
            String(session?.[key] || '').trim() && String(actor?.[key] || '').trim()
        ));
        if (!keys.length) return true;
        return keys.some((key: string) => String(session[key]) === String(actor[key]));
    }

    private restoredRequestText(value: any) {
        const text = String(value || '').trim();
        const marker = '사용자의 세부 요구:';
        const markerIndex = text.lastIndexOf(marker);
        return markerIndex >= 0 ? text.slice(markerIndex + marker.length).trim() : text;
    }

    private async post(request: any) {
        const body = new URLSearchParams();
        body.set('payload', JSON.stringify(request));
        const response = await fetch(this.operatorUrl, {
            method: 'POST', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, body
        });
        const payload = await this.readPayload(response);
        const code = Number(payload?.code ?? response.status);
        if (!response.ok || (Number.isFinite(code) && code >= 400)) {
            throw new Error(payload?.message || payload?.data?.message || '요청을 처리하지 못했습니다.');
        }
        return this.unwrap(payload);
    }

    private async mutateWorkspace(request: any) {
        const body = new URLSearchParams();
        body.set('payload', JSON.stringify(request));
        const response = await fetch(this.managementUrl, {
            method: 'POST', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, body
        });
        const payload = await this.readPayload(response);
        const code = Number(payload?.code ?? response.status);
        if (!response.ok || (Number.isFinite(code) && code >= 400)) {
            throw new Error(payload?.message || payload?.data?.message || '하네스 요청을 처리하지 못했습니다.');
        }
        const result = this.unwrap(payload);
        if (!result?.state || !result?.item) throw new Error('하네스 저장 응답이 올바르지 않습니다.');
        return result;
    }

    private async readPayload(response: Response) {
        try { return await response.json(); } catch (error) { return null; }
    }

    private unwrap(payload: any) {
        const candidates = [payload?.data?.data, payload?.data, payload?.result, payload];
        return candidates.find((item: any) => item && typeof item === 'object') || {};
    }

    private createConversationId() {
        const values = new Uint32Array(2);
        window.crypto.getRandomValues(values);
        return `CHAT-editor-${Date.now().toString(36)}-${values[0].toString(36)}${values[1].toString(36)}`;
    }

    private scrollConversation() {
        requestAnimationFrame(() => {
            const element = document.querySelector('.resource-editor-chat__messages');
            if (element) element.scrollTop = element.scrollHeight;
        });
    }
}

export default PageProjectResourceEditorComponent;